import { CREATE_CAMPAIGN_MANAGEMENT, CREATE_CAMPAIGN_MANAGEMENT_SUCCESS, CREATE_CAMPAIGN_MANAGEMENT_ERROR, CREATE_CAMPAIGN_MANAGEMENT_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateCampaignManagement = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CAMPAIGN_MANAGEMENT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_CAMPAIGN_MANAGEMENT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_CAMPAIGN_MANAGEMENT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_CAMPAIGN_MANAGEMENT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateCampaignManagement;
